document.addEventListener('DOMContentLoaded', function() {
  if (!window.location.pathname.includes('/tracking')) {
    return;
  }

  function updateStatusChips() {
    const statusChips = document.querySelectorAll('.wndr--shipment-status-chip');

    statusChips.forEach(function(statusChip) {
      const text = statusChip.textContent.trim();
      
      if (statusChip.classList.contains('pre_transit') && text === 'Pre Transit') {
        statusChip.textContent = 'Order Packed';
      }

      if (statusChip.classList.contains('transit') && text === 'Transit') {
        statusChip.textContent = 'In Transit';
      }

      if (statusChip.classList.contains('transit') && text === 'Returned') {
        statusChip.textContent = 'Returning to Sender';
      }

      if (statusChip.classList.contains('returned') && text === 'Returned') {
        statusChip.textContent = 'Returned to Sender';
      }

      if (statusChip.classList.contains('pending') && text === 'Order placed. Awaiting fulfillment') {
        statusChip.textContent = 'Order Placed';
      }
    });
  }

  function updateTransitProgressSteps() {
    const stepLabels = document.querySelectorAll('.tp-step-label');

    stepLabels.forEach(function(label) {
      const text = label.textContent.trim();

      if (text === 'Pre Transit') {
        label.textContent = 'Order Packed';
      }

      if (text === 'Transit') {
        label.textContent = 'In Transit';
      }
    });
  }

  function updateReturnedProgressSteps() {
    const steps = document.querySelectorAll('.tp-step-completed');

    steps.forEach(function(step) {
      const label = step.querySelector('.tp-step-label');

      if (!label) {
        return;
      }

      const text = label.textContent.trim();

      if (step.classList.contains('transit') && text === 'Returned') {
        label.textContent = 'Returning to Sender';
      }

      if (step.classList.contains('returned') && text === 'Returned') {
        label.textContent = 'Returned to Sender';
      }
    });
  }

  function updateStatusDescriptions() {
    const messages = document.querySelectorAll('.wndr--shipment-status-message');

    messages.forEach(function(message) {
      const text = message.textContent.trim();

      if (text === 'We are working on your order, please check back later.') {
        message.textContent = 'We received your order and are getting it ready to ship! Check back soon for tracking updates';
      }
    });
  }

  function updateStatusHeaderBlock() {
    const headers = document.querySelectorAll('.tp-shipment-header.wndr--shipment-status-header');

    headers.forEach(function(header) {
      const preTransitChip = header.querySelector('.pre_transit.wndr--shipment-status-chip');

      if (!preTransitChip) {
        return;
      }

      if (header.querySelector('.wndr--message-block')) {
        return;
      }

      const messageBlock = document.createElement('div');
      messageBlock.className = 'wndr--message-block';

      const span = document.createElement('span');
      span.className = 'wndr--shipment-status-message';
      span.textContent = 'Your order is ready to ship! Check back soon for tracking updates';

      messageBlock.appendChild(span);
      header.appendChild(messageBlock);
    });
  }

  function updateStatusLabels() {
    updateStatusChips();
    updateTransitProgressSteps();
    updateReturnedProgressSteps();
    updateStatusDescriptions();
    updateStatusHeaderBlock();
  }

  updateStatusLabels();

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length) {
        updateStatusLabels();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});